import { forwardRef, type Ref, type SVGProps } from "react";

function SvgScallopedCheckWithStar(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} width="91" height="89" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <mask
        id="mask0_100_6549"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="6"
        y="3"
        width="85"
        height="85"
      >
        <path
          d="M38.2959 9.68457C43.707 4.27367 52.4805 4.27366 57.8916 9.68457L58.8047 10.5986C60.7738 12.5677 63.4447 13.6738 66.2295 13.6738H66.4619C74.1144 13.6738 80.3184 19.8778 80.3184 27.5303V27.7627C80.3184 30.5475 81.4244 33.2184 83.3936 35.1875L84.3066 36.1006C89.7178 41.5117 89.7178 50.2852 84.3066 55.6963L83.3936 56.6094C81.4244 58.5785 80.3184 61.2494 80.3184 64.0342V64.2666C80.3184 71.9191 74.1144 78.123 66.4619 78.123H66.2295C63.4447 78.123 60.7738 79.2291 58.8047 81.1982L57.8916 82.1113C52.4805 87.5225 43.707 87.5225 38.2959 82.1113L37.3828 81.1982C35.4137 79.2291 32.7428 78.123 29.958 78.123H29.7256C22.0731 78.123 15.8691 71.9191 15.8691 64.2666V64.0342C15.8691 61.2494 14.7631 58.5785 12.7939 56.6094L11.8799 55.6963C6.46898 50.2852 6.46898 41.5117 11.8799 36.1006L12.7939 35.1875C14.7631 33.2184 15.8691 30.5475 15.8691 27.7627V27.5303C15.8691 19.8778 22.0731 13.6738 29.7256 13.6738H29.958C32.7428 13.6738 35.4137 12.5677 37.3828 10.5986L38.2959 9.68457Z"
          fill="url(#paint0_linear_100_6549)"
          stroke="#9ED79D"
          strokeWidth="3.35598"
        />
      </mask>
      <g mask="url(#mask0_100_6549)">
        <path
          d="M38.2959 9.68457C43.707 4.27367 52.4805 4.27366 57.8916 9.68457L58.8047 10.5986C60.7738 12.5677 63.4447 13.6738 66.2295 13.6738H66.4619C74.1144 13.6738 80.3184 19.8778 80.3184 27.5303V27.7627C80.3184 30.5475 81.4244 33.2184 83.3936 35.1875L84.3066 36.1006C89.7178 41.5117 89.7178 50.2852 84.3066 55.6963L83.3936 56.6094C81.4244 58.5785 80.3184 61.2494 80.3184 64.0342V64.2666C80.3184 71.9191 74.1144 78.123 66.4619 78.123H66.2295C63.4447 78.123 60.7738 79.2291 58.8047 81.1982L57.8916 82.1113C52.4805 87.5225 43.707 87.5225 38.2959 82.1113L37.3828 81.1982C35.4137 79.2291 32.7428 78.123 29.958 78.123H29.7256C22.0731 78.123 15.8691 71.9191 15.8691 64.2666V64.0342C15.8691 61.2494 14.7631 58.5785 12.7939 56.6094L11.8799 55.6963C6.46898 50.2852 6.46898 41.5117 11.8799 36.1006L12.7939 35.1875C14.7631 33.2184 15.8691 30.5475 15.8691 27.7627V27.5303C15.8691 19.8778 22.0731 13.6738 29.7256 13.6738H29.958C32.7428 13.6738 35.4137 12.5677 37.3828 10.5986L38.2959 9.68457Z"
          fill="url(#paint1_linear_100_6549)"
          stroke="#9ED79D"
          strokeWidth="3.35598"
        />
        <g filter="url(#filter0_f_100_6549)">
          <path
            d="M137.441 39.2353L154.099 53.5884L59.1539 135.78L42.4957 121.427L137.441 39.2353Z"
            fill="#E8F9E1"
          />
        </g>
        <g filter="url(#filter1_f_100_6549)">
          <path
            d="M165.886 59.4775L172.441 65.126L77.4966 147.318L70.941 141.67L165.886 59.4775Z"
            fill="#E8F9E1"
          />
        </g>
        <path
          d="M34.3906 50.5125L42.6128 59.3219L61.7978 35.8301"
          stroke="url(#paint2_linear_100_6549)"
          strokeWidth="8.54507"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M10.6102 1.9362C10.6102 1.56801 10.3118 1.26953 9.94358 1.26953C9.57539 1.26953 9.27691 1.56801 9.27691 1.9362C9.27691 4.70976 8.66476 6.55461 7.50226 7.71711C6.33976 8.87961 4.49491 9.49175 1.72135 9.49175C1.35316 9.49175 1.05469 9.79023 1.05469 10.1584C1.05469 10.5266 1.35316 10.8251 1.72135 10.8251C4.49491 10.8251 6.33976 11.4372 7.50226 12.5997C8.66476 13.7622 9.27691 15.6071 9.27691 18.3806C9.27691 18.7488 9.57539 19.0473 9.94358 19.0473C10.3118 19.0473 10.6102 18.7488 10.6102 18.3806C10.6102 15.6071 11.2224 13.7622 12.3849 12.5997C13.5474 11.4372 15.3922 10.8251 18.1658 10.8251C18.534 10.8251 18.8325 10.5266 18.8325 10.1584C18.8325 9.79023 18.534 9.49175 18.1658 9.49175C15.3922 9.49175 13.5474 8.87961 12.3849 7.71711C11.2224 6.55461 10.6102 4.70976 10.6102 1.9362Z"
        fill="#0D2B57"
      />
      <defs>
        <filter
          id="filter0_f_100_6549"
          x="34.4957"
          y="31.2344"
          width="127.603"
          height="112.547"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="4" result="effect1_foregroundBlur_100_6549" />
        </filter>
        <filter
          id="filter1_f_100_6549"
          x="62.941"
          y="51.4766"
          width="117.5"
          height="103.842"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="4" result="effect1_foregroundBlur_100_6549" />
        </filter>
        <linearGradient
          id="paint0_linear_100_6549"
          x1="30.7266"
          y1="7.30469"
          x2="48.0937"
          y2="84.4922"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F2E8" />
          <stop offset="1" stopColor="#B9EBBA" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_100_6549"
          x1="30.7266"
          y1="7.30469"
          x2="48.0937"
          y2="84.4922"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F2E8" />
          <stop offset="1" stopColor="#B9EBBA" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_100_6549"
          x1="38.9585"
          y1="38.7666"
          x2="45.904"
          y2="60.0371"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#094534" />
          <stop offset="1" stopColor="#4D9863" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgScallopedCheckWithStar);
export default ForwardRef;
